import { useEffect } from "react";
import { absoluteUrl } from "../../utils/seoData";

const ensureMetaTag = (selector, attributes) => {
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement("meta");
    document.head.appendChild(tag);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    tag.setAttribute(key, value);
  });

  return tag;
};

const ensureCanonical = (href) => {
  let tag = document.head.querySelector('link[rel="canonical"]');

  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", "canonical");
    document.head.appendChild(tag);
  }

  tag.setAttribute("href", href);

  return tag;
};

const snapshotTag = (selector) => {
  const tag = document.head.querySelector(selector);

  if (!tag) {
    return { selector, html: null };
  }

  return { selector, html: tag.outerHTML };
};

const restoreTag = ({ selector, html }) => {
  const tag = document.head.querySelector(selector);

  if (html) {
    if (tag) {
      tag.outerHTML = html;
    } else {
      document.head.insertAdjacentHTML("beforeend", html);
    }
  } else if (tag?.parentNode) {
    tag.parentNode.removeChild(tag);
  }
};

function SeoHead({ title, description, canonicalPath }) {
  useEffect(() => {
    const previousTitle = document.title;
    const previousTags = [
      snapshotTag('meta[property="og:title"]'),
      snapshotTag('meta[name="twitter:title"]'),
      snapshotTag('meta[name="description"]'),
      snapshotTag('meta[property="og:description"]'),
      snapshotTag('meta[name="twitter:description"]'),
      snapshotTag('link[rel="canonical"]'),
      snapshotTag('meta[property="og:url"]'),
    ];

    if (title) {
      document.title = title;
      ensureMetaTag('meta[property="og:title"]', { property: "og:title", content: title });
      ensureMetaTag('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    }

    if (description) {
      ensureMetaTag('meta[name="description"]', { name: "description", content: description });
      ensureMetaTag('meta[property="og:description"]', { property: "og:description", content: description });
      ensureMetaTag('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    }

    if (canonicalPath) {
      const canonicalUrl = absoluteUrl(canonicalPath);
      ensureCanonical(canonicalUrl);
      ensureMetaTag('meta[property="og:url"]', { property: "og:url", content: canonicalUrl });
    }

    return () => {
      document.title = previousTitle;
      previousTags.forEach(restoreTag);
    };
  }, [title, description, canonicalPath]);

  return null;
}

export default SeoHead;
